import React from 'react'
import {useTranslation} from 'react-i18next'
import useHealthCenterStyles from 'pages/HealthCenter/ReportV1/HealthCenterMajorIndicators/Style'
import down from 'pages/HealthCenter/ReportV1/HealthCenterMajorIndicators/down.svg'
import useLanguage from 'features/languageReport/useLanguage'

interface Props {
  headerName: string
  backgroundColor: string
  textRound: {
    value: number
    frequency?: string
    status: string
  }
  percentage: number
  index: number
  top: string
  middle: string
  bottom: string
  showHz?: boolean
  isEEG?: boolean
}

function PercentChangeBarCard({
  headerName,
  backgroundColor,
  textRound,
  percentage,
  index,
  top,
  middle,
  bottom,
  showHz = true,
  isEEG = false,
}: Props) {
  const {t, i18n} = useTranslation()
  const classes = useHealthCenterStyles()
  const {scoreUnit, textFiveMajorAPI: textAPI} = useLanguage(
    isEEG ? 'eeg' : 'health',
  )

  const percentile = textAPI?.threshold.t_score || {
    low: 30,
    high: 70,
  }

  const getNumber = (value: string | number) => {
    if (!Number.isNaN(Number(value))) return value
    return 0
  }
  return (
    <div className={classes.percentBar}>
      <div style={{paddingBottom: 25}}>
        <div className={classes.percentBarHeaderName}>
          <p>{headerName}</p>
        </div>
        <div
          className={classes.arrowIconShort}
          // Offset of the arrow icon's size
          style={{marginLeft: `${percentage - 1}%`}}
        />

        <div className={classes.colorBarNormal}>
          <div
            className={classes.marker1}
            style={{
              left: `${percentile.low}%`,
            }}
          />
          <div
            className={classes.marker1}
            style={{
              left: `${percentile.high}%`,
            }}
          />

          <div
            className={classes.colorBarFillNormal}
            style={{
              width: `${Number(percentage) ?? 0}%`,
              backgroundColor: `${backgroundColor}`,
            }}
          />
        </div>
        <div className={classes.contentBarPerNotificationV2}>
          <div className={classes.contentBarPerNotificationV2Child}>
            <div style={{position: 'absolute', left: `${percentile.low - 4}%`}}>
              {top}
            </div>
            <div style={{position: 'absolute', left: `${50 - 4}%`}}>
              {middle}
            </div>
            <div
              style={{position: 'absolute', left: `${percentile.high - 4}%`}}
            >
              {bottom}
            </div>
          </div>
        </div>
      </div>
      <div
        className={classes.round}
        style={{
          backgroundColor: `${backgroundColor}`,
        }}
      >
        <div className={classes.textRound}>
          <p>
            {getNumber(textRound.value)}
            {i18n.language !== 'en' && scoreUnit}
          </p>
          {textRound.frequency && textRound.frequency !== '0' && showHz && (
            <p className={`${classes.frequencyText} ${classes.textRoundItem2}`}>
              {textRound.frequency}
            </p>
          )}
          <p className={classes.textRoundItem3}>{textRound.status}</p>
        </div>
      </div>
    </div>
  )
}

export default PercentChangeBarCard
